import r from "react";
import { mintelGray50 as t, mintelGray400 as m } from "mintel-tokens";
import { u as a } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as n } from "./index-Dd-4N6BE.es.js";
const c = ({
  children: o
}) => {
  const e = a();
  return /* @__PURE__ */ r.createElement(n.Body3, { color: e ? t : m, responsive: !0 }, o);
};
export {
  c as F
};
